import React from 'react'
import styled from 'styled-components'
import { wh, fadeInAnimation, tabletMinWidth } from '../mixins'
import { isBrowser } from 'react-device-detect'

const Container = styled.div`
  ${wh('100%')};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: ${({ customJustify }) => customJustify || 'flex-start'};
  ${({ customColor }) => customColor && 'background-color:' + customColor + ';'}
  padding: ${({ customPadding }) => customPadding || '19px 24px 24px'};
  ${isBrowser && fadeInAnimation};
  position: relative;
  ${({ customStyles }) => customStyles};

  @media screen and (min-width: ${tabletMinWidth}px) {
    ${wh('100%')};
    justify-content: ${({ customTabletJustify }) =>
      customTabletJustify || 'flex-start'};
    padding-left: calc(
      (100% - ${({ desktopWidth }) => desktopWidth || '462'}px) / 2
    );
    padding-right: calc(
      (100% - ${({ desktopWidth }) => desktopWidth || '462'}px) / 2
    );
    ${({ desktopPadding }) => desktopPadding && 'padding:0;'}
    ${({ customDesktopStyles }) => customDesktopStyles};
  }

  @media screen and (min-width: ${tabletMinWidth}px) and (max-height: ${({
      adaptiveHeight,
    }) => adaptiveHeight - 1 || 700}px) {
    justify-content: ${({ customTabletMaxJustify }) =>
      customTabletMaxJustify || 'flex-start'};
  }
`

const MainContainer = ({
  children,
  customColor,
  customPadding,
  customJustify,
  customTabletJustify,
  customTabletMaxJustify,
  desktopWidth,
  desktopPadding,
  adaptiveHeight,
  customStyles,
  customDesktopStyles,
}) => {
  return (
    <Container
      customColor={customColor}
      customPadding={customPadding}
      customJustify={customJustify}
      customTabletJustify={customTabletJustify}
      customTabletMaxJustify={customTabletMaxJustify}
      desktopWidth={desktopWidth}
      desktopPadding={desktopPadding}
      adaptiveHeight={adaptiveHeight}
      customStyles={customStyles}
      customDesktopStyles={customDesktopStyles}
    >
      {children}
    </Container>
  )
}

export default MainContainer
